import { lazy } from 'react'
import { Canvas } from '@react-three/fiber'
import { WebGL1Renderer } from 'three'

import Resizer from '@/webgl/helpers/Resizer'
import useSettings from '@/webgl/hooks/useSettings'

const Scene = lazy(() => import('@/webgl/components/Scene'))

const Stage = () => {
  const { dpr, needsWebgl1 } = useSettings()

  return (
    <Canvas
      id="stage"
      gl={
        needsWebgl1()
          ? (canvas) =>
              new WebGL1Renderer({
                canvas,
                powerPreference: 'default',
                antialias: true,
                stencil: false,
                depth: false
              }) as any
          : {
              powerPreference: 'default',
              autoClear: false,
              antialias: true,
              stencil: false,
              depth: false
            }
      }
      style={{ position: 'fixed', top: 0, left: 0, height: '100vh', zIndex: 0 }}
      onCreated={(state) => state.gl.setClearColor('#ffffff')}
      camera={{ fov: 50 }}
      dpr={[1, dpr]}
    >
      <color attach="background" args={['#ffffff']} />
      <Resizer />
      <Scene />
    </Canvas>
  )
}

export default Stage
